module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "1"
    }
  }, [_c('informa')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "成员",
      "name": "2"
    }
  }, [_c('member', {
    attrs: {
      "refs": "member"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "设置",
      "name": "3"
    }
  }, [_c('setup')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3de4aaae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/unitmanage/unit.vue
// module id = 1214
// module chunks = 2